module.exports = __webpack_public_path__ + "img/intro-bg-mobile.284164f0.jpg";